import * as React from "react";

function SvgTreasureData(props, ref) {
  return (
    <svg
      viewBox="0 0 45 35"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M8 2h30l7 7-22 24L1 9l7-7z" fill="#FF5F5F" fillRule="evenodd" />
    </svg>
  );
}

export default React.forwardRef(SvgTreasureData);
